import React, { FunctionComponent, useEffect } from 'react';
import Accordion, { AccordionProps } from '../accordion/accordion-component';
import styles from './accordion-group-component.module.scss';

type AccordionGroupProps = {
  accordions: AccordionProps[];
  /**
   * Cannot contain double underscore '\__'
   */
  groupName: string;
};

export const AccordionGroup: FunctionComponent<AccordionGroupProps> = (props: AccordionGroupProps) => {
  const headerIds = props.accordions.map((_, index) => props.groupName + '__' + index);

  useEffect(() => {
    function onKeyDownFocus(e: KeyboardEvent) {
      let id = '';

      for (let i = 0; i < headerIds.length; i++) {
        if (document.activeElement === document.getElementById(headerIds[i])) {
          id = headerIds[i]; //store id of active accordion header
          break;
        }
      }

      //if an accordion header is active
      if (id !== '') {
        const index = parseInt(id.split('__')[1]);

        //down arrow
        if (e.keyCode === 40) {
          document.getElementById(id)?.blur();

          if (index === props.accordions.length - 1) {
            document.getElementById(headerIds[0])?.focus(); //focus topmost accordion in group
          } else {
            document.getElementById(headerIds[index + 1])?.focus();
          }
        }
        //up arrow
        else if (e.keyCode === 38) {
          document.getElementById(id)?.blur();

          if (index === 0) {
            document.getElementById(headerIds[headerIds.length - 1])?.focus(); //focus last accordion in group
          } else {
            document.getElementById(headerIds[index - 1])?.focus();
          }
        }
        //End key
        else if (e.keyCode === 35) {
          document.getElementById(id)?.blur();
          document.getElementById(headerIds[headerIds.length - 1])?.focus(); //focus last accordion in group
        }
        //Home key
        else if (e.keyCode === 36) {
          document.getElementById(id)?.blur();
          document.getElementById(headerIds[0])?.focus(); //focus topmost accordion in group
        }
      }
    }

    window.addEventListener('keydown', onKeyDownFocus);

    return () => {
      window.removeEventListener('keydown', onKeyDownFocus);
    };
  }, [headerIds, props.accordions.length]);

  return (
    <div className={styles['accordion-group']}>
      {props.accordions.map((accordionProps, i) => {
        return <Accordion key={headerIds[i]} {...accordionProps} headerId={headerIds[i]} />;
      })}
    </div>
  );
};

export default AccordionGroup;
